import React from 'react'
// Local
import If from './if'
import ReveleerHeaderLogo from '../logos/ReveleerHeaderLogo'
import { shouldRenderReskin2025 } from '../../constant'

/**
 * @return Path to company logo image based on state of BRANDING_IDENTITY
 */
const companyLogoPath = '/asset/image/curation-logo-no-tag.png'

function HeaderLogo(): JSX.Element {
  return (
    <>
      <If isTrue={ !shouldRenderReskin2025 }>
        <img
          src={ companyLogoPath }
          className="ui small image"
          alt="Curation Healthcare"
        />
      </If>
      <If isTrue={ shouldRenderReskin2025 }>
        <ReveleerHeaderLogo />
      </If>
    </>
  )
}

export default HeaderLogo
